import {Modal, Button, Typography} from "antd";
import {useEffect, useState} from "react";
import {t} from "i18next";
import ApiService from "../core/service/ApiService";

/**
 * Login sonrası gösterilen ticari ileti onay modalı. Sürtünmesiz giriş için aydınlatma login altında pasif
 * link olarak kalır; ticari rıza ise burada OPSİYONEL sorulur (onaylıyorum / onaylamıyorum). Modal yalnızca
 * ticari rıza toplanıyorsa, hasta test-izinliyse ve henüz karar vermemişse backend tarafından "show" döner.
 * Mobil uyumlu: dar ekranda butonlar tam genişlik ve büyük.
 */
export default function TicariConsentModal() {
    const [prompt, setPrompt] = useState(null);
    const [open, setOpen] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        ApiService.PatientApp.GetTicariConsentPrompt().then(res => {
            if (res.success && res.data?.show) {
                setPrompt(res.data);
                setOpen(true);
            }
        });
    }, []);

    const decide = async (approved) => {
        setSaving(true);
        const res = await ApiService.PatientApp.SetTicariConsent(approved);
        setSaving(false);
        if (res.success) {
            setOpen(false);
        }
    };

    if (!prompt) {
        return null;
    }

    return (
        <Modal
            open={open}
            title={t('Commercial electronic message')}
            centered
            closable={false}
            maskClosable={false}
            width={420}
            footer={null}
        >
            <Typography.Paragraph style={{marginBottom: 12}}>
                {t('Would you like to receive commercial electronic messages such as campaigns and announcements from us?')}
            </Typography.Paragraph>

            {
                prompt.sampleMessage && (
                    <div
                        style={{
                            background: '#f5f5f5',
                            border: '1px solid #e8e8e8',
                            borderRadius: 6,
                            padding: 12,
                            marginBottom: 12,
                            whiteSpace: 'pre-line',
                            fontSize: '11pt',
                            color: '#595959'
                        }}
                    >
                        {prompt.sampleMessage}
                    </div>
                )
            }

            {
                prompt.ticariUrl && (
                    <div style={{marginBottom: 16}}>
                        <a href={prompt.ticariUrl} target="_blank" rel="noreferrer" style={{fontSize: 12}}>
                            {t('Commercial electronic message')}
                        </a>
                    </div>
                )
            }

            <Button
                type="primary"
                size="large"
                block
                loading={saving}
                style={{height: 45, marginBottom: 8}}
                onClick={() => decide(true)}
            >
                {t('I approve')}
            </Button>
            <Button
                size="large"
                block
                disabled={saving}
                style={{height: 45}}
                onClick={() => decide(false)}
            >
                {t('I do not approve')}
            </Button>
        </Modal>
    );
}
